const r = {
  borderWidth: 1,
  borderRadius: "full"
};
export {
  r as base
};
